
import es from './es.js';
import en from './en.js';
import frCA from './fr-CA.js';

export default {
  en, es, 'fr-CA': frCA, 'en-US': en
}